(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.da = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      autocomplete: {
        noDataMessage: 'Der blev ikke fundet nogen data'
      },
      combobox: {
        placeholder: 'Vælg',
        searchPlaceholder: 'Søg'
      },
      datepicker: {
        apply: 'Anvend',
        clearSelection: 'Ryd',
        pickADays: 'Vælg dage',
        prevYear: 'Forrige år',
        nextYear: 'Næste år',
        prevMonth: 'Forrige måned',
        nextMonth: 'Næste måned',
        year: '',
        month1: 'Januar',
        month2: 'Februar',
        month3: 'Marts',
        month4: 'April',
        month5: 'Maj',
        month6: 'Juni',
        month7: 'Juli',
        month8: 'August',
        month9: 'September',
        month10: 'Oktober',
        month11: 'November',
        month12: 'December',
        weeks: {
          sun: 'Søn',
          mon: 'Man',
          tue: 'Tir',
          wed: 'Ons',
          thu: 'Tor',
          fri: 'Fre',
          sat: 'Lør'
        },
        months: {
          jan: 'Jan',
          feb: 'Feb',
          mar: 'Mar',
          apr: 'Apr',
          may: 'Maj',
          jun: 'Jun',
          jul: 'Jul',
          aug: 'Aug',
          sep: 'Sep',
          oct: 'Okt',
          nov: 'Nov',
          dec: 'Dec'
        },
        pickADay: 'Vælg en dag'
      },
      timepicker: {
        meridiemAM: 'AM',
        meridiemPM: 'PM'
      },
      dropdown: {
        noDataMessage: 'Der blev ikke fundet nogen data'
      },
      filepicker: {
        browse: 'Gennemse',
        select: 'Vælg en fil'
      },
      filter: {
        apply: 'Anvend',
        cancel: 'Annuller',
        filterButton: 'Filter',
        reset: 'Nulstil filtre',
        resetDefault: 'Nulstil til standard'
      },
      search: {
        noDataMessage: 'Der blev ikke fundet nogen data'
      },
      'multi-search': {
        'separator-and': 'OG',
        'search-button': 'Søg',
        'search-placeholder': 'Søg efter navn'
      },
      select: {
        all: 'Alle',
        clearSelection: 'Ryd valgte',
        noMatch: 'Der blev ikke fundet nogen data',
        noData: 'Ingen data',
        placeholder: 'Vælg',
        item: 'emne(r)',
        selected: 'markeret',
        found: 'blev fundet'
      },
      upload: {
        browseButton: 'Gennemse',
        text: 'Træk og slip filer for at uploade, eller klik på "Gennemse"',
        tip: 'Du kan uploade 10 filer på op til 25 MB hver'
      },
      table: {
        emptyText: 'Ingen data'
      },
      tree: {
        emptyText: 'Ingen data'
      }
    }
  };
  _exports.default = _default;
});